<template>
  <div>
    <transition appear @before-enter="$animations.beforeEnterLogoArea" @enter="$animations.enterLogoArea">
      <Logo></Logo>
    </transition>
    <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en`" class="column" style="text-align: center">
          <img src="../assets/images/icons/updatedIcons/kekuluFlow/accountHolderInfo.png" alt="contact-img" width="85%" />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <!-- <img src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37572.png" alt="contact-img" width="70%" /> -->
        </div>
      </div>
    </transition>
    <div class="card px-3 py-5  " style="width: 80%; margin: 0 auto 80px auto; ">

      <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
        <div class="columns is-centered">





          <div class="column ps-5" style="text-align: center">
            <img src="../assets/images/icons/Blue/Group 158.png" alt="contact-info-img" width="70" height="70" />
            <p :class="`text-center mx-3 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
              }`"
               style="font-family: OpenSans-Bold">
              {{ $root.selectedLanguageData.account_holder_information }}
            </p>
            <p :class="`${$root.selectedLanguage === `ta`
              ? `ta-sub-line`
              : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
              }`"
               style="font-family: OpenSans-Bold">
              {{ $root.selectedLanguageData.tell_us_more_about_the_minor}}
            </p>
            <p style="font-family: OpenSans-Regular">
              {{ $root.selectedLanguageData.fill_the_below_form }}
            </p>
          </div>
        </div>
      </transition>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="">
          <div class="columns is-7 is-centered">
            <div class="column is-three-quarters pt-5 ps-5">

              <!--title and surname start-->
              <div class="mt-4 columns">
                <div class="column is-one-quarter">
                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.title }}
                    <span class="has-text-danger">*</span>
                  </label>
                  <ValidationProvider name="Title" :rules="{ required: true }" >
                    <div>
                      <b-select
                          @focus="$inputFocused('title')"
                          @input="$inputChanged('title')"
                          @blur="$inputBlured('title')"
                          v-model="$root.formData.title">
                        <option value="Master">
                          {{ $root.selectedLanguageData.master }}
                        </option>
                        <option value="Miss">
                          {{ $root.selectedLanguageData.miss }}
                        </option>
                        <option value="Rev">
                          {{ $root.selectedLanguageData.rev }}
                        </option>
                      </b-select>
                    </div>
                  </ValidationProvider>
                </div>

                <div class="column">
                  <label :class="`${ $root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.surname }}
                    <span class="has-text-danger">*</span>
                  </label>
                  <div class="field">
                    <p class="control has-icons-right">
                      <ValidationProvider name="Surname" :rules="validateFullName()" v-slot="{ errors }">
                        <b-input type="text" v-model="$root.formData.surname"
                                 @focus="$inputFocused('surname')"
                                 @input="() => {$inputChanged('surname');calName();}"
                                 @blur="$inputBlured('surname')"
                        />
                        <span class="icon is-small is-right">
                        <img
                            src="../assets/images/icons/Blue/Group 158.png"
                            alt="contact-name-img"
                            width="25"
                            height="25"
                        />
                      </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </div>
                </div>
              </div>
              <!--title and surname end-->
              <!--              other name start-->
              <div >
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.otherName }}
                  <span class="has-text-danger">*</span>
                </label>
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider
                        :rules="validateOtherName()"
                        name="Other Name"
                        v-slot="{ errors }">
                      <b-input type="text"
                               v-model="$root.formData.other_name"
                               @focus="$inputFocused('surname')"
                               @input="() => {$inputChanged('surname');}"
                               @blur="$inputBlured('surname')"/>
                      <span class="icon is-small is-right mr-2">
                      <img
                          src="../assets/images/icons/Blue/Group 158.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                      />
                    </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>
              <!--              other name end-->

              <!-- Gender and DOB start-->
              <div class="field mt-4 is-flex is-justify-content-space-between ">
                <div>
                <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                  {{ $root.selectedLanguageData.gender}}
                  <span class="has-text-danger">*</span>
                </label>

                <div class="columns">
                  <div class="column is-one-two">
                    <b-field>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <b-radio name="gender" style="font-family: OpenSans-Regular" native-value="Male"
                                 @focus="$inputFocused('gender')" @input="$inputChanged('gender')"
                                 @blur="$inputBlured('gender')" v-model="$root.formData.gender">
                          {{$root.selectedLanguageData.male }}
                        </b-radio>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <div class="column is-one-two">
                    <b-field>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <b-radio name="gender" style="font-family: OpenSans-Regular" native-value="Female"
                                 @focus="$inputFocused('gender')" @input="$inputChanged('gender')"
                                 @blur="$inputBlured('gender')" v-model="$root.formData.gender">
                          {{ $root.selectedLanguageData.female }}
                        </b-radio>
                        <span class="has-text-danger">{{errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
                </div>

                <div>
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.dateofBirth}}
                    <span class="has-text-danger">*</span>
                  </label>
                  <b-field>
                    <p class="control has-icons-right">
                      <ValidationProvider name="Date of birth" :rules="{ required: true }"  v-slot="{ errors }">
                        <b-datepicker
                            class="date-picking"
                            icon-right="calendar-today"
                            @focus="$inputFocused('account_holder_dob')"
                            @input="$inputChanged('account_holder_dob')"
                            @blur="$inputBlured('account_holder_dob')"
                            v-model="$root.formData.account_holder_dob"
                            :min-date="minDate"
                            :max-date="maxDate"
                        >
                        </b-datepicker>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </b-field>
                </div>

              </div>
              <!-- Gender and DOB end-->

<!--              occupation start here-->
            <div class="columns mt-4">
              <div class="column ">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.occupation }}
                  <span class="has-text-danger">*</span>
                </label>
                <ValidationProvider name="Account holder occupation" :rules="{ required: true }" >
                    <b-select
                        @focus="$inputFocused('occupation')"
                        @input="()=>{
                          $inputChanged('occupation')
                        }"
                        @blur="$inputBlured('occupation')"
                        v-model="$root.formData.occupation" expanded>
                      <option value="Student" >
                        {{ $root.selectedLanguageData.student }}
                      </option>
                      <option value="Other">
                        {{ $root.selectedLanguageData.other }}
                      </option>
                    </b-select>
                </ValidationProvider>
              </div>
              <div class="column " v-if="$root.formData.occupation === 'Student'">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                  {{ $root.selectedLanguageData.grade }}
                  <span class="has-text-danger">*</span>
                </label>
                <ValidationProvider name="Grade" :rules="{ required: true }" >
                  <div>
                    <b-select
                        @focus="$inputFocused('grade')"
                        @input="test()"
                        @blur="$inputBlured('grade')"
                        v-model="$root.formData.grade"
                        expanded>
                      <option v-for="n in grades" :key="'grade' + n" :value="n">

                        {{ $root.selectedLanguageData.grade + " " + n }}
                      </option>

                    </b-select>
                  </div>
                </ValidationProvider>
              </div>

            </div>
<!--              occupation end here-->
<!--              if occupation is other this section will active-->

              <div class="mt-4"  v-if="$root.formData.occupation === 'Other'">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.specify_the_occupation }}
                  <span class="has-text-danger">*</span>
                </label>
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider
                        name="Occupation"
                        :rules="{ required: true }"
                        v-slot="{ errors }">
                      <b-input type="text"
                               v-model="$root.formData.other_occupation"
                               @focus="$inputFocused('other_occupation')"
                               @input="() => {$inputChanged('other_occupation');}"
                               @blur="$inputBlured('other_occupation')"/>
                      <span class="icon is-small is-right mr-2">
                      <img
                          src="../assets/images/icons/Blue/Group 158.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                      />
                    </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>

<!--              if person student this sections will active ****-->
<!--school field start here-->
              <div class="mt-4"  v-if="$root.formData.occupation === 'Student'">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.school }}
                  <span class="has-text-danger">*</span>
                </label>
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider
                        name="School"
                        :rules="{ required: true }"
                        v-slot="{ errors }">
                      <b-input type="text"
                               v-model="$root.formData.school"
                               @focus="$inputFocused('school')"
                               @input="() => {$inputChanged('school');}"
                               @blur="$inputBlured('school')"/>
                      <span class="icon is-small is-right mr-2">
                      <img
                          src="../assets/images/icons/Blue/Group 158.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                      />
                    </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>
              <!--school field end here-->

              <!--              year and grade fields start here-->
<!--              <div class="columns mt-4"  v-if="$root.formData.occupation === 'Student'">-->
<!--                <div class="column is-two-fifths">-->
<!--                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">-->
<!--                    {{ $root.selectedLanguageData.year }}-->
<!--                    <span class="has-text-danger">*</span>-->
<!--                  </label>-->
<!--                  <ValidationProvider :rules="{ required: true }" >-->
<!--                    <b-input type="text" v-model="$root.formData.surname"-->
<!--                             @focus="$inputFocused('surname')"-->
<!--                             @input="() => {$inputChanged('surname');calName();}"-->
<!--                             @blur="$inputBlured('surname')"-->
<!--                             disabled-->
<!--                    />-->
<!--                  </ValidationProvider>-->
<!--                </div>-->
<!--                <div class="column is-two-fifths is-offset-one-fifth">-->
<!--                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">-->
<!--                    {{ $root.selectedLanguageData.grade }}-->
<!--                    <span class="has-text-danger">*</span>-->
<!--                  </label>-->
<!--                  <ValidationProvider name="your name title" :rules="{ required: true }" >-->
<!--                    <div>-->
<!--                      <b-select-->
<!--                          @focus="$inputFocused('grade')"-->
<!--                          @input="test()"-->
<!--                          @blur="$inputBlured('grade')"-->
<!--                          v-model="$root.formData.grade"-->
<!--                          expanded>-->
<!--                        <option v-for="n in grades" :key="'grade' + n" :value="n">-->

<!--                          {{ $root.selectedLanguageData.grade + " " + n }}-->
<!--                        </option>-->

<!--                      </b-select>-->
<!--                    </div>-->
<!--                  </ValidationProvider>-->
<!--                </div>-->
<!--              </div>-->
              <!--              year and grade fields end here-->

              <!--              residency section start-->
              <div class="field mt-4">
                <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                  {{ $root.selectedLanguageData.residency}}
                  <span class="has-text-danger">*</span>
                </label>

                <div class="columns">
                  <div class="column is-one-quarter">
                    <b-field>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <b-radio name="residence" style="font-family: OpenSans-Regular" native-value="Resident in Sri Lanka"
                                 @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"
                                 @blur="$inputBlured('residentship')" v-model="$root.formData.residentship">
                          {{$root.selectedLanguageData.residentInSriLanka }}
                        </b-radio>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <div class="column is-one-two">
                    <b-field>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <b-radio name="residence" style="font-family: OpenSans-Regular" native-value="Non Resident"
                                 @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"
                                 @blur="$inputBlured('residentship')" v-model="$root.formData.residentship">
                          {{ $root.selectedLanguageData.nonResident }}
                        </b-radio>
                        <span class="has-text-danger">{{errors[0]}}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
              </div>
              <!--              residency section end-->
<!--              if account holder residency not in sri lanka select country section will active-->
              <div v-if="
                  $root.formData.residentship ===
                  `Non Resident`">
                <div>
                  <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
                    {{
                      $root.selectedLanguageData
                          .specifyTheCountry
                    }}<span class="has-text-danger">*</span></label>

                  <div>
                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <div style="width: 100%">
                        <b-select @focus="$inputFocused('resident_country')"
                                  @input="$inputChanged('resident_country')"
                                  @blur="$inputBlured('resident_country')" v-model="$root.formData.resident_country"
                                  expanded>
                          <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                            {{ country.countryName }}
                          </option>
                        </b-select>
                      </div>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
<!--              country selection section end-->

<!--              citizenship and passport number section start-->

              <!-- Citizenship select start here -->
              <div class="columns mt-4"> <!-- (v-if="$root.kycFieldVisibility.citizenship") need to add -->
                <div class="column">
                <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.nationalityCitizenship
                  }}<span class="has-text-danger">*</span></label>
                <div style="width: 100%">
                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <b-select style="width: 100%" expanded v-model="$root.formData.citizenship"
                              @focus="$inputFocused('citizenship')" @input="
                        () => {
                          $inputChanged('citizenship');
                          dualCitizenCounties();
                        }
                      " @blur="$inputBlured('citizenship')">
                      <option value="Sri Lankan">
                        {{ $root.selectedLanguageData.srilanka }}
                      </option>
                      <option value="Sri Lankan with Dual Citizenship">
                        {{
                          $root.selectedLanguageData
                              .sriLankanWithDualCitizenship
                        }}
                      </option>

                    </b-select>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                </div>
                <!-- Citizenship select end here -->



<!--                <div class="column">-->
<!--                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">-->
<!--                    {{ $root.selectedLanguageData.passport_no}}-->
<!--                    <span class="has-text-danger">*</span>-->
<!--                  </label>-->
<!--                  <b-field>-->
<!--                    <p class="control has-icons-right">-->
<!--                      <ValidationProvider name="Account Holder Passport Number" v-slot="{ errors }">-->
<!--                        <b-input type="text" @focus="$inputFocused('account_holder_passport_number')" @input="$inputChanged('account_holder_passport_number')"-->
<!--                                 @blur="$inputBlured('account_holder_passport_number')" v-model="$root.formData.account_holder_passport_number" />-->
<!--                        <span class="icon is-small is-right">-->
<!--                              <img-->
<!--                                  src="../assets/images/icons/Blue/Edit.png"-->
<!--                                  alt="contact-name-img"-->
<!--                                  width="25"-->
<!--                                  height="25"-->
<!--                              />-->
<!--                            </span>-->
<!--                        <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </p>-->
<!--                  </b-field>-->
<!--                </div>-->
                <!--                if citizenship is dual-->
                <div v-if="$root.formData.citizenship === 'Sri Lankan with Dual Citizenship'" class="column">

                    <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
                      {{
                        $root.selectedLanguageData
                            .specifyTheCountry
                      }}<span class="has-text-danger">*</span></label>

                    <!--                    citizenship country-->
                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('citizenship_country')"
                                    @input="$inputChanged('citizenship_country')"
                                    @blur="$inputBlured('citizenship_country')" v-model="$root.formData.citizenship_country"
                                    expanded>
                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                </div>
              </div>
              <!--              citizenship and passport number section end-->

<!--              passport number and expire date section start here-->
              <div class="columns mt-4">
                <div class="column">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.passport_no}}
                    <span class="has-text-danger" v-if="$root.formData.residentship === 'Non Resident'">*</span>
                  </label>
                  <b-field>
                    <p class="control has-icons-right">
                      <ValidationProvider name="Passport Number" v-slot="{ errors }" :rules="passportValidation()">
                        <b-input type="text" @focus="()=>{$inputFocused('account_holder_passport_number'); if($root.formData.account_holder_passport_number === ''){
                              $root.formData.account_holder_passport_issue_date = '';
                              $root.formData.account_holder_passport_expiry_date = '';

                            }}" @input="$inputChanged('account_holder_passport_number')"
                                 @blur="$inputBlured('account_holder_passport_number')" v-model="$root.formData.account_holder_passport_number" />
                        <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </b-field>
                </div>

                <div class="column ">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.passport_issued_date}}
                    <span class="has-text-danger"  v-if="$root.formData.residentship === 'Non Resident'">*</span>
                  </label>
                  <b-field>
                    <p class="control has-icons-right">
                      <ValidationProvider name="Passport issue date" v-slot="{ errors }" :rules="passportMandotoryValidate()">
                        <b-datepicker
                            class="date-picking is-half"
                            icon-right="calendar-today"
                            @focus="$inputFocused('account_holder_passport_issue_date')"
                            @input="$inputChanged('account_holder_passport_issue_date'); passportExpireDateCalculator()"
                            @blur="$inputBlured('account_holder_passport_issue_date')"
                            v-model="$root.formData.account_holder_passport_issue_date"
                            :max-date="passportIssueMaxDate"
                            :disabled="$root.formData.account_holder_passport_number===''"
                        >
                        </b-datepicker>

                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </b-field>
                </div>


              </div>

<!--                            passport number and expire date section end here-->

<!--              passport expire date section start here-->
              <div class="columns">
                              <div class="column">
                                <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                                  {{ $root.selectedLanguageData.passport_expiry_date}}
                                  <span class="has-text-danger"  v-if="$root.formData.residentship === 'Non Resident'">*</span>
                                </label>
                                <b-field>
                                  <p class="control has-icons-right">
                                    <ValidationProvider name="Passport expiry date" :rules="passportMandotoryValidate()" v-slot="{ errors }">
                                      <b-datepicker
                                          class="date-picking"
                                          icon-right="calendar-today"
                                          :disabled="$root.formData.account_holder_passport_number===''"

                                          @focus="$inputFocused('account_holder_passport_expiry_date')"
                                          @input="$inputChanged('account_holder_passport_expiry_date')"
                                          @blur="$inputBlured('account_holder_passport_expiry_date')"
                                          v-model="$root.formData.account_holder_passport_expiry_date"
                                          :min-date="passportExpireMinDate"
                                      >
                                      </b-datepicker>

                                      <span class="has-text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                  </p>
                                </b-field>
                              </div>
              </div>
<!--              passport expire date end here-->


              <hr>


              <!-- address -->
              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                  {{ $root.selectedLanguageData.permanentAddress }}
                </label>
                <!--permanent address house name-->
                <div class="mt-1">
                  <p>
                    {{ $root.selectedLanguageData.houseName }}
                    <span class="has-text-danger">*</span>
                  </p>
                  <b-field>
                    <ValidationProvider name="Permanent address line 1" :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                      <p class="control has-icons-right">
                        <b-input type="text" @focus="$inputFocused('permanent_address_line1')"
                                 @input="$inputChanged('permanent_address_line1')"
                                 @blur="$inputBlured('permanent_address_line1')"
                                 v-model="$root.formData.permanent_address_line1"></b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="columns is-7 is-variable mt-2">
                  <!--permanent address street name-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.streetName }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider  name="Permanent address line 2" :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('permanent_address_line2')"
                                   @input="$inputChanged('permanent_address_line2')"
                                   @blur="$inputBlured('permanent_address_line2')"
                                   v-model="$root.formData.permanent_address_line2"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--permanent address city-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.city }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider name="Permanent address line 3" :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('permanent_address_line3')"
                                   @input="$inputChanged('permanent_address_line3')"
                                   @blur="$inputBlured('permanent_address_line3')"
                                   v-model="$root.formData.permanent_address_line3"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>

                <div class="columns is-7 is-variable">
                  <!--permanent address postal code-->
                  <div class="column">
                    <p>{{ $root.selectedLanguageData.postalCode }}</p>
                    <b-field>
                      <ValidationProvider name="Permanent address postal code" :rules="{ regex: /^\d{5}$/, notEndsWith: ' ' }" v-slot="{ errors }">
                      <p class="control has-icons-right">
                        <b-input type="text" @focus="$inputFocused('permanent_address_postal_code')"
                                 @input="$inputChanged('permanent_address_postal_code')"
                                 @blur="$inputBlured('permanent_address_postal_code')"
                                 v-model="$root.formData.permanent_address_postal_code">
                        </b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>
                         <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-field>
                  </div>
                  <!--permanent address country-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.country }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('permanent_address_country')"
                                    @input="$inputChanged('permanent_address_country')"
                                    @blur="$inputBlured('permanent_address_country')"
                                    v-model="$root.formData.permanent_address_country" expanded>
                            <option v-for="country in $root.selectedLanguageData
                                .countries" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                  {{ $root.selectedLanguageData.mailingAddress }}</label>
                <b-field>
                  <b-checkbox type="is-primary" @focus="$inputFocused('mailing_address_same_as_permanent_address')"
                              @input="$inputChanged('mailing_address_same_as_permanent_address')"
                              @blur="$inputBlured('mailing_address_same_as_permanent_address')"
                              v-model="$root.formData.mailing_address_same_as_permanent_address"
                              :disabled="!$root.formData.permanent_address_line1 ||
                                !$root.formData.permanent_address_line2 ||
                                !$root.formData.permanent_address_line3 ||!
                                $root.formData.permanent_address_country"
                              @change.native="mailingAddress()">
                    <p style="font-size: 0.9rem">{{$root.selectedLanguageData.sameAsPermanentAddress }}</p>
                  </b-checkbox>
                </b-field>

                <!--mailing address house name-->
                <div class="mt-1">
                  <p>
                    {{ $root.selectedLanguageData.houseName }}
                    <span class="has-text-danger">*</span>
                  </p>
                  <b-field>
                    <ValidationProvider name="Mailing address line 1" :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                      <p class="control has-icons-right">
                        <b-input type="text" @focus="$inputFocused('mailing_address_line1')"
                                 @input="$inputChanged('mailing_address_line1')"
                                 @blur="$inputBlured('mailing_address_line1')"
                                 v-model="$root.formData.mailing_address_line1"
                                 :disabled="$root.formData.mailing_address_same_as_permanent_address">
                        </b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="columns is-7 is-variable mt-2">
                  <!--mailing address street name-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.streetName }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider name="Mailing address line 2" :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('mailing_address_line2')"
                                   @input="$inputChanged('mailing_address_line2')"
                                   @blur="$inputBlured('mailing_address_line2')"
                                   v-model="$root.formData.mailing_address_line2"
                                   :disabled="$root.formData.mailing_address_same_as_permanent_address">
                          </b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--mailing address city-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.city }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider name="Mailing address line 3" :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('mailing_address_line3')"
                                   @input="$inputChanged('mailing_address_line3')"
                                   @blur="$inputBlured('mailing_address_line3')" v-model="$root.formData.mailing_address_line3"
                                   :disabled="$root.formData.mailing_address_same_as_permanent_address"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
                <div class="columns is-7 is-variable">
                  <!--mailing postal code-->
                  <div class="column">
                    <p>{{ $root.selectedLanguageData.postalCode }}</p>
                    <b-field>
                       <ValidationProvider name="Mailing address postal code" :rules="{ regex: /^\d{5}$/, notEndsWith: ' ' }" v-slot="{ errors }">
                      <p class="control has-icons-right">
                        <b-input type="text" @focus="$inputFocused('mailing_address_postal_code')"
                                 @input="$inputChanged('mailing_address_postal_code')"
                                 @blur="$inputBlured('mailing_address_postal_code')"
                                 v-model="$root.formData.mailing_address_postal_code"
                                 :disabled="$root.formData.mailing_address_same_as_permanent_address">
                        </b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>
                       <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-field>
                  </div>
                  <!--mailing address country-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.country }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('mailing_address_country')"
                                    @input="$inputChanged('mailing_address_country')"
                                    @blur="$inputBlured('mailing_address_country')"
                                    v-model="$root.formData.mailing_address_country"
                                    :disabled="$root.formData.mailing_address_same_as_permanent_address" expanded>
                            <option v-for="country in $root.selectedLanguageData
                                .countries" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                </div>


                <div class="columns is-flex is-justify-content-flex-end">
                  <div
                      class="column is-6 is-offset-4 is-flex is-flex-direction-row-reverse"
                  >

                    <!--                        @click="$router.push('guardians_information')"-->
                    <b-button
                        :disabled="invalid"
                    @click="submitPageInputs(isContinueButtonLoading, 'guardians_information', 'otp', 'guardians_information', 1)"
                        :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"


                    >
                      <!--@click="$router.push('otp')"-->
                      <!-- :disabled="invalid || userCode !== $root.formData.countryCode" -->

                      {{ $root.selectedLanguageData.continue }}
                    </b-button>
                    <b-button
                        @click="$router.push('otp')"
                        :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"

                    >{{ $root.selectedLanguageData.back }}
                    </b-button>
                  </div>
                </div>
            </div>
          </div>
        </form>
      </ValidationObserver>

      <b-modal v-model="isModalOneActive" :can-cancel="false">
        <transition appear
                    @before-enter="$animations.beforeEnterBelow"
                    @enter="$animations.enterBelow"
        >
        <div class="opacity-select-card card" style="width: 100%; margin: auto; ">
          <header class="card-header">
            <p class="card-header-title is-centered is-size-4" style="font-family: OpenSans-Bold">
              {{ $root.selectedLanguageData.terms_conditions }}
            </p>
          </header>
          <div class="card-content">
            <ul class="example-ul mx-6 has-text-left">
              <li class="mb-3">
                {{$root.selectedLanguageData.please_open_a_minors_account_in_the_name_of_the_above_mentioned}}
              </li>

              <li class="mb-3">
                {{$root.selectedLanguageData.payment_should_be_made_to_the_account_holder}}
              </li>

              <li class="mb-3">
                {{$root.selectedLanguageData.inTheEventOfTheAccountHolder}}
              </li>

              <li class="mb-3">
                {{$root.selectedLanguageData.agreeToOpenMinorAccount}}
              </li>
            </ul>
          </div>

          <div class="is-flex is-justify-content-flex-end pb-4">
            <b-button class="reject-button"  @click="$router.push('account-info')">
              <!-- rounded propertiey has removed -->
              {{ $root.selectedLanguageData.reject }}
            </b-button>
            <b-button
                class="is-primary mr-4 agree-button"
                :loading="continueButtonIsLoading"
                @click="()=>{
                  isModalTwoActive = true
                  isModalOneActive =false
                }"

            >
              {{ $root.selectedLanguageData.agree }}
            </b-button>
          </div>
        </div>
        </transition>
      </b-modal>


      <b-modal v-model="isModalTwoActive" :can-cancel="false">
        <transition appear
                    @before-enter="$animations.beforeEnterBelow"
                    @enter="$animations.enterBelow"
        >
          <div class="opacity-select-card card" style="width: 100%; margin: auto; ">
            <header class="card-header">
              <p class="card-header-title is-centered is-size-4" style="font-family: OpenSans-Bold">
                {{ $root.selectedLanguageData.notice }}
              </p>
            </header>
            <div class="card-content" style="display: flex; justify-content: center">

            <div>
              {{ $root.selectedLanguageData.youAreExpectedToCompleteThis }}
            </div>

            </div>
            <div class="card-content" style="display: flex; justify-content: center">
              <b-button
                  style="margin: 0 auto"
                  class="is-primary agree-button"
                  :loading="continueButtonIsLoading"
                  @click="()=>{
                  isModalTwoActive = false
                }"
              >
                {{ $root.selectedLanguageData.ok }}
              </b-button>
            </div>
          </div>
        </transition>
      </b-modal>


    </div>
  </div>

</template>

<script>
import Logo from "./NsbKycLogo.vue";
import {submitPageInputs} from "@/util/util";
export default {
  data(){
    const today = new Date()
    return{
      minDate : new Date(today.getFullYear() - 14, today.getMonth(), today.getDate()),
      maxDate : new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      grades : [1,2,3,4,5,6,7,8,9,10],
      countriesArray: [],
      passportExpireMinDate : new Date(today.getFullYear(), today.getMonth(), today.getDate()+1),
      passportIssueMaxDate : new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      isModalOneActive : (this.$root.formData.childrenAccountOpeningPurpose === "For my own child" || this.$root.formData.haveNic === 'No') ? true : this.$root.formData.childrenAccountOpeningPurpose === "For another person's child (Gift Account)" ? false: null,
      isModalTwoActive : this.$root.formData.childrenAccountOpeningPurpose === "For another person's child (Gift Account)" ? true: (this.$root.formData.childrenAccountOpeningPurpose === "For my own child" || this.$root.formData.haveNic === 'No')  ? false: null,
      submitPageInputs : submitPageInputs,
      isContinueButtonLoading : false
    }
  },

  components:{
    Logo
  },
  methods:{


    test: function(){
      console.log(this.$root.formData.grade)
    },
    mailingAddress() {
      if (this.$root.formData.mailing_address_same_as_permanent_address) {
        this.$root.formData.mailing_address_line1 =
            this.$root.formData.permanent_address_line1;
        this.$root.formData.mailing_address_line2 =
            this.$root.formData.permanent_address_line2;
        this.$root.formData.mailing_address_line3 =
            this.$root.formData.permanent_address_line3;
        this.$root.formData.mailing_address_postal_code =
            this.$root.formData.permanent_address_postal_code;
        this.$root.formData.mailing_address_country =
            this.$root.formData.permanent_address_country;
      } else {
        this.$root.formData.mailing_address_line1 = "";
        this.$root.formData.mailing_address_line2 = "";
        this.$root.formData.mailing_address_line3 = "";
        this.$root.formData.mailing_address_postal_code = "";
        this.$root.formData.mailing_address_country = "";
      }
    },




    validateFullName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        customerName: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
      }
      return obj;
    },

    passportValidation(){

      let obj = {
        regex: /^[0-9A-Za-z]{4,18}$/,
        required: this.$root.formData.residentship === "Non Resident",
      };
      return obj;
    },
    passportMandotoryValidate(){
      if (this.$root.formData.residentship === "Non Resident"){
        let obj = {
          required: true,
        };
        return obj;
      }
    },

    validateOtherName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
      };
      return obj;
    },
    passportExpireDateCalculator(){

      if( this.$root.formData.account_holder_passport_issue_date !== ''){
        console.log("this.$root.formData.account_holder_passport_issue_date",)
        this.$root.formData.account_holder_passport_expiry_date = new Date(this.$root.formData.account_holder_passport_issue_date.getFullYear()+10, this.$root.formData.account_holder_passport_issue_date.getMonth(), this.$root.formData.account_holder_passport_issue_date.getDate())
      }
    },
  },

  mounted() {
    this.countriesArray = this.$root.selectedLanguageData.countries.filter(
        (item) => item.value !== "Sri Lanka"
    );
  }

}
</script>

<style lang="scss" scoped>
    ul li::before {
      content: "\2022";
      color: #009ec2;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
    .specific {
      margin-left: -20px;
      line-height: 1.5rem;
    }
</style>